import { useFormContext } from 'react-hook-form';
import { P, Section, Stack } from '@fashionnovateam/nova-ui-toolkit';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { ItemDetailsFormData } from './types';

export function StockDetailsSection() {
  const { control } = useFormContext<ItemDetailsFormData>();

  return (
    <Section
      icon="package/package-02"
      title="Stock Details"
      color="neutral"
      className="w-full flex flex-col"
    >
      <Stack direction="col" gap="md">
        <Stack direction="row" gap="md">
          <ControlledFormInput
            name="stockQuantity"
            label="Stock Quantity"
            control={control}
            inputType="number"
            inputProps={{
              placeholder: '0',
              className: 'w-full',
              min: '0',
              endAdornment: (
                <P size="xs" color="disabled">
                  units
                </P>
              ),
            }}
          />
          <ControlledFormInput
            name="stockRatio"
            label="Stock Ratio"
            control={control}
            inputType="text"
            rules={{
              pattern: {
                value: /^\d+(-\d+)+$/,
                message:
                  'Stock ratio must be numbers separated by hyphens (e.g. 1-1-1 or 1-2-3-4)',
              },
            }}
            inputProps={{
              className: 'w-full',
              placeholder: '0-0-0',
            }}
          />
          <ControlledFormInput
            name="stockIhd"
            label="Stock IHD"
            control={control}
            inputType="date"
            inputProps={{
              placeholder: 'Add',
              containerClassName: 'w-full',
              className: 'w-full',
            }}
          />
        </Stack>
        <Stack direction="row" gap="md">
          <ControlledFormInput
            name="incomingStockQuantity"
            label="Incoming Stock Quantity"
            control={control}
            inputType="number"
            inputProps={{
              placeholder: '0',
              className: 'w-full',
              min: '0',
              endAdornment: (
                <P size="xs" color="disabled">
                  units
                </P>
              ),
            }}
          />
          <ControlledFormInput
            name="incomingStockRatio"
            label="Incoming Stock Ratio"
            control={control}
            inputType="text"
            rules={{
              pattern: {
                value: /^\d+(-\d+)+$/,
                message:
                  'Incoming stock ratio must be numbers separated by hyphens (e.g. 1-1-1 or 1-2-3-4)',
              },
            }}
            inputProps={{
              className: 'w-full',
              placeholder: '0-0-0',
            }}
          />
          <ControlledFormInput
            name="incomingStockDate"
            label="Incoming Stock Date"
            control={control}
            inputType="date"
            inputProps={{
              placeholder: 'Add',
              containerClassName: 'w-full',
              className: 'w-full',
            }}
          />
        </Stack>
      </Stack>
    </Section>
  );
}
